import { DEFAULT_UI } from '../constants'

export const initialUiState = {
  ui: { ...DEFAULT_UI },
}
